<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <large-base-card
    :color="color+' lighten-5'"
    :style="$vuetify.breakpoint.mobile?{
      height:'112px'
    }:{height: '148px'}"
    class="d-flex align-center"
    style="height: 148px"
  >
    <v-sheet
      class="d-flex align-start justify-center flex-column"
      color="transparent"
      style="height: 100%"
      width="100%"
      @click="$emit('click')"
    >
      <v-skeleton-loader
        v-if="loading"
        height="148"
        type="card"
        width="100%"
      />
      <template v-else>
        <div
          class="d-flex align-center"
          style="width: 100%"
        >
          <div
            :class="($vuetify.breakpoint.mobile?'text-body-2':'text-body-1')"
            style="width: 100%"
          >
            <span
              class="text-truncate"
            >
              {{ title }}
            </span>
          </div>
          <v-spacer />
          <v-icon v-if="clickable">
            mdi-chevron-right
          </v-icon>
        </div>
        <div
          class="text-caption text--secondary"
          style="width: 100%"
        >
          {{ subtitle }}
        </div>
        <v-spacer />
        <slot>
          <div class="d-flex align-baseline">
            <div
              :class="color+'--text '+($vuetify.breakpoint.mobile?'text-h4':'text-h3')"
              class="font-weight-bold text-no-wrap mr-4"
              v-html="info"
            />
          </div>
        </slot>
      </template>
    </v-sheet>
    <v-spacer />
    <slot name="action" />
  </large-base-card>
</template>

<script>
import LargeBaseCard from '@/views/widget/commonDecoration/LargeBaseCard.vue'

export default {
  name: 'DashboardCard',
  components: { LargeBaseCard },
  props: {
    title: {},
    subtitle: {},
    info: {},
    color: {},
    loading: {},
    clickable: {}
  }
}
</script>

<style scoped>

</style>
